import { FormControl, FormLabel, Text } from "@chakra-ui/react";

export default function FloatLabel({ label, children, isRequired = false, height }) {
	return (
		<FormControl height={height} pos="relative">
			<FormLabel fontWeight="semibold" position="absolute" top="-3" insetStart="3" bg="white" zIndex={2} px="0.3rem">
				{label}{" "}
				{isRequired && (
					<Text as="b" color="red.400">
						*
					</Text>
				)}
			</FormLabel>
			{children}
		</FormControl>
	);
}
